/* Header: mobile drawer menu, search toggle, and scroll border. Loaded by sections/header.liquid. */
(function () {
  (() => {
    const hamburger = document.querySelector('[data-hamburger]');
    const drawer = document.querySelector('[data-drawer]');
    const drawerClose = drawer?.querySelector('[data-drawer-close]');
    const searchToggle = document.querySelector('[data-search-toggle]');
    const drawerSearchInput = drawer?.querySelector('.header__drawer-search-input');

    if (hamburger && drawer) {
      hamburger.addEventListener('click', () => {
        drawer.showModal();
        hamburger.setAttribute('aria-expanded', 'true');
      });
    }

    if (searchToggle && drawer) {
      searchToggle.addEventListener('click', () => {
        drawer.showModal();
        hamburger?.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          drawerSearchInput?.focus();
        });
      });
    }

    if (drawerClose && drawer) {
      drawerClose.addEventListener('click', () => {
        drawer.close();
      });
    }

    if (drawer) {
      drawer.addEventListener('open', () => {
        document.body.style.overflow = 'hidden';
        drawerClose?.focus();
      });

      drawer.addEventListener('close', () => {
        document.body.style.overflow = '';
        if (hamburger) {
          hamburger.setAttribute('aria-expanded', 'false');
          hamburger.focus();
        }
        resetDrawerPanels();
      });

      drawer.addEventListener('click', (e) => {
        if (e.target === drawer) drawer.close();
      });

      const drawerNav = drawer.querySelector('[data-drawer-nav]');

      function resetDrawerPanels() {
        if (!drawerNav) return;
        drawerNav.querySelectorAll('.header__drawer-panel--active').forEach((panel) => {
          panel.classList.remove('header__drawer-panel--active');
        });
        drawerNav.querySelector('[data-panel="root"]')?.classList.add('header__drawer-panel--active');
      }

      drawer.querySelectorAll('.header__drawer-link').forEach((link) => {
        const item = link.closest('[data-item]');
        const hasChildren = item?.querySelector('.header__drawer-sublist') || item?.querySelector('[data-panel-trigger]');
        if (hasChildren) return;
        link.addEventListener('click', () => drawer.close());
      });

      // Rows with a nested submenu (level 1) toggle it open/closed inline on
      // a click anywhere in the row, instead of navigating.
      drawer.querySelectorAll('.header__drawer-item-row').forEach((row) => {
        const item = row.closest('[data-item]');
        const sublist = item?.querySelector('.header__drawer-sublist');
        if (!sublist) return;

        row.addEventListener('click', (e) => {
          e.preventDefault();

          const isOpen = sublist.classList.contains('header__drawer-sublist--open');
          sublist.classList.toggle('header__drawer-sublist--open');

          const toggle = row.querySelector('[data-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', !isOpen);
        });
      });

      // Rows with a product submenu (level 2) open it as a full drill-in
      // panel instead of navigating, with a dedicated back button to return.
      drawerNav?.querySelectorAll('[data-panel-trigger]').forEach((row) => {
        const targetId = row.getAttribute('data-panel-trigger');
        const target = drawerNav.querySelector(`[data-panel="${targetId}"]`);
        if (!target) return;

        row.addEventListener('click', (e) => {
          e.preventDefault();
          drawerNav.querySelectorAll('.header__drawer-panel--active').forEach((panel) => {
            panel.classList.remove('header__drawer-panel--active');
          });
          target.classList.add('header__drawer-panel--active');
          target.querySelector('.header__drawer-back')?.focus();
        });
      });

      drawerNav?.querySelectorAll('[data-panel-back]').forEach((btn) => {
        btn.addEventListener('click', () => {
          resetDrawerPanels();
        });
      });
    }

    // Mega menu
    const headerEl = document.querySelector('[data-header]');
    const megaOpen = headerEl?.dataset.megaOpen || 'hover';
    const triggers = document.querySelectorAll('[data-mega-trigger]');

    let hoverTimeout = null;

    function closeMegaMenus(except) {
      document.querySelectorAll('[data-mega-menu]').forEach((m) => {
        if (m !== except) m.removeAttribute('data-active');
      });
      document.querySelectorAll('[data-mega-trigger]').forEach((t) => {
        if (t !== except) {
          t.removeAttribute('aria-expanded');
          t.querySelector('.header__nav-chevron')?.classList.remove('header__nav-chevron--active');
        }
      });
    }

    triggers.forEach((trigger) => {
      const handle = trigger.dataset.megaTrigger;
      const menu = document.querySelector(`[data-mega-menu="${handle}"]`);
      if (!menu) return;

      if (megaOpen === 'hover') {
        const item = trigger.closest('.header__nav-item');

        function showMega() {
          clearTimeout(hoverTimeout);
          closeMegaMenus(trigger);
          menu.setAttribute('data-active', '');
          trigger.setAttribute('aria-expanded', 'true');
          trigger.querySelector('.header__nav-chevron')?.classList.add('header__nav-chevron--active');
        }

        function hideMega() {
          hoverTimeout = setTimeout(() => {
            menu.removeAttribute('data-active');
            trigger.removeAttribute('aria-expanded');
            trigger.querySelector('.header__nav-chevron')?.classList.remove('header__nav-chevron--active');
          }, 200);
        }

        // The trigger and its menu panel are siblings, not nested (the menu
        // renders in its own loop elsewhere in the header), so hiding on
        // blur has to check whether focus landed in either one
        // before closing — otherwise tabbing from the trigger into its own
        // menu links (or around within them) would close the menu instead
        // of keeping it open, and keyboard users could never reach it.
        function focusStillRelevant(target) {
          return !!target && (trigger.contains(target) || menu.contains(target));
        }

        item?.addEventListener('mouseenter', showMega);
        item?.addEventListener('mouseleave', hideMega);
        menu.addEventListener('mouseenter', () => clearTimeout(hoverTimeout));
        menu.addEventListener('mouseleave', hideMega);

        trigger.addEventListener('focus', showMega);
        trigger.addEventListener('blur', (e) => {
          if (!focusStillRelevant(e.relatedTarget)) hideMega();
        });
        menu.addEventListener('focusin', () => clearTimeout(hoverTimeout));
        menu.addEventListener('focusout', (e) => {
          if (!focusStillRelevant(e.relatedTarget)) hideMega();
        });
      }

      if (megaOpen === 'click') {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = menu.hasAttribute('data-active');
          closeMegaMenus();
          if (!isOpen) {
            menu.setAttribute('data-active', '');
            trigger.setAttribute('aria-expanded', 'true');
            trigger.querySelector('.header__nav-chevron')?.classList.add('header__nav-chevron--active');
          }
        });
      }
    });

    if (megaOpen === 'click') {
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-mega-trigger]') && !e.target.closest('[data-mega-menu]')) {
          closeMegaMenus();
        }
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeMegaMenus();
      }
    });
  })();

  function handleScrollBorder() {
    var header = document.querySelector('.header');
    if (!header) return;
    if (window.scrollY > 50) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  }
  window.addEventListener('scroll', handleScrollBorder, { passive: true });
  handleScrollBorder();
})();
